import { render, staticRenderFns } from "./ordinaryList.vue?vue&type=template&id=519f24f4&scoped=true"
import script from "./ordinaryList.vue?vue&type=script&lang=js"
export * from "./ordinaryList.vue?vue&type=script&lang=js"
import style0 from "./ordinaryList.vue?vue&type=style&index=0&id=519f24f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519f24f4",
  null
  
)

export default component.exports